import React from "react";
import brandPhoto from "./../../../assets/img/auth-brand-photo.jpg";
import ezycompWhite from "./../../../assets/img/auth-ezycomp-white.png";
import cielPoweredBy from "./../../../assets/img/auth-ciel-powered-by.png";
import partnerLogos from "./../../../assets/img/auth-partner-logos.png";

function AuthBrandPanel() {
    return (
        <div className="ciel-auth-brand">
            <div className="ciel-auth-brand-photo-group">
                <img className="ciel-auth-brand-photo" src={brandPhoto} alt="" />
                <div className="ciel-auth-brand-photo-overlay" />
            </div>
            <div className="ciel-auth-brand-scrim" />
            <div className="ciel-auth-brand-content">
                <img className="ciel-auth-brand-logo" src={ezycompWhite} alt="ezyCOMP" />
                <div className="ciel-auth-brand-message">
                    <div className="ciel-auth-brand-headline">
                        <h1>Every part of<br />the employee journey.</h1>
                        <p>Built for every stage of work, from onboarding to growth.</p>
                    </div>
                    <div className="ciel-auth-brand-powered-by">
                        <span>POWERED BY</span>
                        <img src={cielPoweredBy} alt="CIEL HR" />
                    </div>
                    <div className="ciel-auth-brand-rule" />
                    <div className="ciel-auth-brand-group">
                        <span>PART OF THE CIEL HR GROUP</span>
                        <img src={partnerLogos} alt="Ma Foi, People Metrics, HfactoR, Vibrant, Jombay, Thomas" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AuthBrandPanel;
